import React, {Component} from "react"

import Form from "@irati/ui/src/Form"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"
import {H2} from "@irati/ui/src/Headings"
import TeamName from "@irati-web/fields/team/PublicName"
import Loading from "@irati/ui/src/Loading"
import adminTracking from "@irati-tracking/admin"
import teamService from "@irati/identity/services/teams"
import {Team} from "@irati/types"
import authentication from "@irati/auth"

import {StyledDiv, StyledH4, LeftAlign, MarginRightButton} from "./styled"

interface Props extends InjectIntl {
  onSubmit: (team: Team) => void,
  onBack: () => void
}

interface State {
  name: string,
  submit: Promise<any> | null
}

class CreateTeamName extends Component<Props, State> {
  static defaultProps = {
    onBack: null
  }

  state: State = {
    name: "",
    submit: null
  }

  handleChange = (name: string) => {
    this.setState({name})
  }

  handleNameSubmit = () => {
    const {onSubmit} = this.props
    const public_name = this.state.name.trim()

    const submit = teamService.create({
      tenantId: authentication.userTenant().uuid,
      data: {public_name}
    }, true, true).then((team: Team) => {
      return onSubmit(team)
    })

    this.setState({submit})
    adminTracking.createTeam(public_name)

    return submit
  }

  render() {
    const {submit, name} = this.state
    const {formatMessage, onBack} = this.props

    return (
      <StyledDiv>
        <H2>
          <FormattedMessage id="admin.components.createTeamName.headerTwo" />
        </H2>
        <StyledH4>
          <FormattedMessage id="admin.components.createTeamName.headerFour" />
        </StyledH4>
        <Form form="create-team">
          <LeftAlign>
            <TeamName value={name} onChange={this.handleChange} />
          </LeftAlign>
          {onBack && (
            <MarginRightButton large onClick={onBack}>
              <FormattedMessage id="admin.components.createTeamName.button.back" />
            </MarginRightButton>
          )}
          <ValidationButton
            id="continueButton"
            primary
            load={submit}
            loading={formatMessage({id: "admin.components.createTeamName.validationButton.loading"})}
            onClick={this.handleNameSubmit}>
            <FormattedMessage id="admin.components.createTeamName.validationButton.continue" />
          </ValidationButton>
        </Form>
        <Loading load={submit} useLoader={false} />
      </StyledDiv>
    )
  }
}

export default injectIntl(CreateTeamName)
